import React from 'react';

const bg_style = { 
	height: '100vh', 
	paddingTop: '40vh', 
	backgroundImage: `url(${"https://designs.ai/videomaker/start/static/footer-bg.png"})`, 
	backgroundSize: 1300,
	backgroundRepeat: 'no-repeat',
	backgroundPosition: 'bottom center',

}

const Mobile_Deterrent = () => {
	return (
		<div class="page-wrapper page-wrapper--main" style={bg_style}>
			<main>
				<div class="mobile-message">
					<div class="header__heading" alt="videomaker">
						<div>
							<div style={{width: '50vw', paddingRight: 15, display: 'inline-block', paddingLeft: 15 }}>
                                <img style={{width: '100%'}}
                                     src={global.config.website_url+"designmaker/start/icons/designs_ai_logo.png"}/>
                            </div>
                            <div style={{display: 'inline-block', width: '50vw', paddingRight: 15 }}>
                                <img
                                	style={{ width: '100%' }}
                                    src={global.config.server_path + 'public/images/logo_designmaker.png'}/>
                            </div>
						</div>
					</div>
					<br />
					<p class="text-center">Designmaker is not supported on mobile devices. Please switch to desktop or tablet for the best experience.</p>
				</div>
			</main>
		</div>
	)
}

export default Mobile_Deterrent;